<template>
  <sui-page>
    <sui-page-header title="Grid UI(Sample)"/>
    <sui-page-contents>
      <sui-showcase-manual-box :raw-file="component">
        <sui-showcase-box title="기본형" :raw-file="sourceB1" collapsible><sample-b1/></sui-showcase-box>
        <sui-showcase-box title="셔틀형" :raw-file="sourceB2" collapsible><sample-b2/></sui-showcase-box>
        <sui-showcase-box title="트리형" :raw-file="sourceB3" collapsible><sample-b3/></sui-showcase-box>
      </sui-showcase-manual-box>
    </sui-page-contents>
  </sui-page>
</template>

<script>
import component from '!raw-loader!~common/components/form/SuiGrid/SuiGrid';

import sampleB1 from             "./sample/comp_grid_sample_b1";
import sourceB1 from '!raw-loader!./sample/comp_grid_sample_b1';
import sampleB2 from             "./sample/comp_grid_sample_b2";
import sourceB2 from '!raw-loader!./sample/comp_grid_sample_b2';
import sampleB3 from             "./sample/comp_grid_sample_b3";
import sourceB3 from '!raw-loader!./sample/comp_grid_sample_b3';


export default {
  name : "compGridSample",
  components : {
    sampleB1,
    sampleB2,
    sampleB3,
  },
  data() {return {
    component,
    sourceB1,
    sourceB2,
    sourceB3,
  }}
}
</script>